let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kwvFG")).then(() => parcelRequire('jh0iZ'));